/**
 * An ISO country code with the country's name after it – "KZ Kazakhstan".
 * Hovering shows the market's population and GDP per capita against
 * Germany's, when the seat recorded them.
 */
import { clsx } from "clsx";

import { useMarketIndex } from "../../api/b2g";
import { countryName, economyLines } from "../../lib/b2g";

export function CountryLabel({ iso2 }: { iso2: string }) {
  const market = useMarketIndex().get(iso2.toUpperCase());
  const name = countryName(iso2);
  const lines = market ? economyLines(market) : [];
  return (
    <span className={clsx("whitespace-nowrap", lines.length > 0 && "cursor-help")} title={lines.join("\n") || undefined}>
      <span className="tnum text-ink-low">{iso2}</span>
      {name !== iso2 ? ` ${name}` : null}
    </span>
  );
}
